const page = `

{settings}
document.title:Stora skillnader i tilltron till HPV-vaccinet
og.title:Stora skillnader i tilltron till HPV-vaccinet
og.image: http://quickshot.imgix.net/hpv/dragbild2.jpg?w=1200&auto=format&q=45&cs=tinysrgb&fp-y=0.2
og.description: I de flesta svenska kommuner har nästan alla flickor fått HPV-vaccin, men i vissa tackar hälften nej visar SVT Nyheters kartläggning.
og.url: http://pejl.svt.se/svt-granskar-hpv-vaccin
siteCatalyst.name: hpv-vaccin
siteCatalyst.category: lyxartikel
{}

[+page]
luft: -48px
{.bild}
fil: hpv/sprutbild.jpg
imgix.fp-y:0.2
storlek: imax
{}

rubrik: Stora skillnader i tilltron till HPV-vaccinet
ingressmulti: Tilltron till HPV-vaccinet, som skyddar mot virus som kan orsaka livmoderhalscancer, varierar stort i Sverige.
ingressmulti: I de flesta kommuner tar nästan alla flickor sprutorna, men i vissa tackar hälften nej visar SVT Nyheters kartläggning.
ingressmulti: – Kan man minska antalet som får den här sjukdomen är det jättebra. För det är inget man vill gå igenom, säger Anna Wallin som drabbades av livmoderhalscancer när hon var gravid.

{.sharebuttons}
title: Stora skillnader i tilltron till HPV-vaccinet
url: http://pejl.svt.se/svt-granskar-hpv-vaccin
{}

Varje år får 50.000 svenska kvinnor veta att de bär på cellförändringar i underlivet på grund av att de smittats av vissa varianter av humant papillomvirus, HPV.

15.000 har så pass allvarliga förändringar att de behöver behandling och runt 550 av dem får, precis som Anna Wallin, veta att cellförändringarna hunnit utvecklas till livmoderhalscancer.

– Jag minns bara att läkaren sprang ut ur rummet. När han kom tillbaka ursäktade han sig och förklarade att han sett något på ultraljudet som han misstänkte kunde vara en tumör, berättar Anna.

Ryggsmärtan hon först trodde berodde på graviditeten och som inte gick över fick sin förklaring. Anna, som då var 25 år, hade drabbats av livmoderhalscancer.

– När magen växte låg barnet och tryckte mot tumören som i sin tur tryckte mot nerverna. Så på ett sätt var det tur att jag blev gravid då så man kunde upptäcka det i tid.

{.bild}
fil: hpv/HPV_Anna_1.jpg
bildtext: Ryggsmärtorna som Anna kände under graviditeten berodde på att barnet i magen tryckte mot tumören.
foto: Privat
storlek: square
imgix.gam:0
imgix.con:20
imgix.exp:-1
imgix.sharp:80
imgix.vib:30
{}


mellanrubrik: Kan förebygga 100 dödsfall per år
Livmoderhalscancer orsakas i stort sett alltid av HPV, som är världens vanligaste sexuellt överförbara virus och som de flesta vuxna någon gång burit på i livet.
Viruset finns i över 100 varianter och vissa av virustyperna kan orsaka cellförändringar som sedan kan leda till olika cancerformer som mun- och halscancer, men livmoderhalscancer är den absolut vanligaste.
Globalt är livmoderhalscancer den fjärde vanligaste orsaken till cancerdöd hos kvinnor och mer än 500.000 nya fall upptäcks varje år och över 250.000 kvinnor dör årligen.

Läkare och forskare är överens om att det bästa sättet att slippa de farligaste typerna av HPV är att vaccinera sig. Sedan 2012 vaccineras svenska flickor i årskurs 5–6 mot de två farligaste typerna av HPV, som tillsammans orsakar cirka 70 procent av alla fall av livmoderhalscancer.

Vaccinet är som mest effektivt om man tar det innan man har haft sex första gången, men även de som redan haft sex minskar risken att drabbas av farliga cellförändringar om de vaccinerar sig.

I dag dör ungefär tre svenska kvinnor i veckan, 150 personer per år, av livmoderhalscancer. Det kan ta 10 till 15 år för sjukdomen att utvecklas och effekten av vaccineringen kommer därför att dröja, men på sikt räknar folkhälsomyndigheten med att HPV-vaccinet kan förebygga 100 dödsfall i livmoderhalscancer årligen.

{.bild}
fil: hpv/diagram_livmoderhalscancer_croppad.png
storlek: texttv
{}

Mellanrubrik: Googlar och tackar nej till vaccin
Sedan HPV-vaccinet introducerades i det svenska barnvaccinationsprogrammet 2012 har i genomsnitt cirka 80 procent av svenska flickorna tagit sprutorna, vilket är relativt högt om man jämför internationellt. Exempelvis är samma siffror för USA 60 procent och Danmark 27 procent.

Men SVT Nyheters kartläggning visar att tilltron till vaccinet varierar stort i Sverige.

I Kalix kommun valde exempelvis nästan alla flickor, 94 procent, att ta sprutan. 15 mil norrut, i Pajala, tackade mer än hälften, 54,5 procent av flickorna nej.

Även i Dalarna är tilltron till HPV-vaccinet betydligt lägre i flera kommuner än riksgenomsnittet. I Vansbro vaccinerades 50 procent av flickorna förra året och i Mora drygt 60 procent.

– Under några år hade vi föräldragrupper på skolor som var väldigt mot vaccinationer. Då är det lätt att en stark föräldragrupp eller en stark förälder påverkar väldigt mycket. Och har de en dotter i skolan så sprider hon ut bland sina kompisar att det är farligt, då blir tveksamma föräldrar ännu mer tveksamma och tackar nej, säger Agneta Englund, skolsjuksköterska i Mora.

Hon brukar ringa upp föräldrarna och fråga om varför.

– Då har de oftast sagt att de har googlat på HPV-vaccin och biverkningar. Och för några år sen kom sidor upp som var väldigt skeptiska mot vaccin överlag och HPV i synnerhet. Så det är klart att om man är rädd och orolig lyssnar man på det som kommer högst upp.

linje:
{.div}
style.position:relative
style.maxWidth: 620px
style.margin: 0 auto


[.+content]
  {.bild}
  fil: hpv/HPV_1-grey.png
  storlek: texttv
  {}
  {.div}
  style.position:absolute
  style.bottom:10px
  style.left:8px
    [.+content]
      rubrik3: [Kolla själv: | remsa]
      luft:-120
      rubrik3: [så ser det ut i din kommun | remsagrey]
    []
  {}
[]
{}
{.iframe}
src: http://pejl.svt.se/stage/hpv-virus-karta/
 storlek:m
height:700px
{}
linje:


Fyra år efter cancerbeskedet är Anna Wallin friskförklarad och både hon och sonen Ludde, fyra år, mår bra. Men cellgiftsbehandlingen var jobbig och Annas livmoder är så pass strålskadad att hon inte kan bära ett barn igen.

– Nu har jag inga äggstockar kvar, men jag har fryst ner mina ägg och det finns ju surrogatmödrar, säger hon.

Anna förstår att det finns en oro över biverkningar från HPV-vaccinet, men säger samtidigt att det är viktigt att man inte går på rykten och att man är källkritisk när man kollar på internet.

– Man tror gärna på det man hör från vänner och bekanta. Men man måste prata med rätt personer. För om vaccinet är så bra som det sägs tycker jag absolut man ska ta det. För kan man minska antalet som får den här sjukdomen så är det ju jättebra. För det är inget man vill gå igenom.

{.bild}
fil: hpv/HPV_Anna_Ludde_2.jpg
foto: Mikael Eriksson/SVT
bildtext: Anna Wallin drabbades av livmoderhalscancer när hon var i gravid. I dag mår både hon och sonen Ludde, fyra år, bra men hennes livmoder är så pass skadad av cellgiftsbehandlingen att hon inte kan bära ett barn igen.
storlek: wide
{}


Mellanrubrik: “Vi är oroliga för komplikationer”
Skolsköterskan Agneta Englund betonar vikten av dialog och berättar att hon alltid försöker bemöta föräldrar och barns oro och rädsla med fakta och kunskap, vilket ibland kan vara svårt då man fått sin information från sajter som larmar om hemska biverkningar från vaccinet.

– Jag förstår ju att föräldrarna säger nej om de tror att vaccinet är farligt. Så då får man ju försöka vända på det och det har hänt flera gånger att när man får till den här dialogen och lyssnar in rädsla och bemöter den med fakta så blir de mer trygga och kan komma fram till beslutet att vaccinera sina barn.

Två mammor som valt att inte vaccinera sina barn är Eva och Jeanette. Vi träffar dem på en innebandyturnering i Mora där de berättar att de är oroliga för biverkningar och att de inte litar på den samlade expertisen som säger att HPV-vaccinet är säkert.

– Jag känner att min dotter är 11 år, hon kan inte besluta om det här själv. Jag vill inte utsätta henne för den här risken. Det bara är så, säger Jeanette.

– Vi är oroliga för komplikationer. Det känns inte tryggt att ge min dotter det, säger Eva.

{.bild}
fil: hpv/maria_grandahl.jpg
storlek: s
foto: Uppsala universitet
bildtext: Föräldrar som Maria Grandahl pratat med oroas över narkolepisi.
imgix.fp-y:0.37
imgix.gam:3
imgix.con:20
imgix.exp:1.4
imgix.sharp:10
{}


Maria Grandahl är forskare vid Uppsala Universitet och har undersökt varför föräldrar tackar nej till just HPV-vaccinet och vilka frågor svenska skolsköterskor får om detsamma.
Hon känner igen invändningarna från föräldrarna.
– Just oron för biverkningar är det absolut vanligaste. Samtliga föräldrar som vi har intervjuat uppgav rädsla för biverkningar som den främsta anledningen till att de tackat nej till HPV-vaccinationen för sin dotter.
luft:10
{.div}
style.backgroundColor:#eee
style.padding:10px
style.maxWidth: 580px
style.margin: 0 auto
[.+content]
luft:-40
[ANALYS|remsa] [Föräldrar förtjänar saklig information om riskerna med HPV-vaccinet|https://www.svt.se/nyheter/vetenskap/analys-foraldrar-fortjanar-saklig-information-om-riskerna-med-hpv-vaccinet]
[]
{}

Maria Grandahl berättar också att nästan alla skolsköterskor som deltagit i en stor attitydundersökning om HPV-vaccinationsprogrammet har fått specifika frågor från föräldrar om just biverkningar av HPV-vaccinet.

Dessutom visar en ny studie som gjorts av Maria Grandahl och hennes kollegor och som publicerats i den vetenskapliga tidskriften Plos One att föräldrarnas frågor om just biverkningar av HPV-vaccinet ökat jämfört med en liknande studie hon gjorde 2013.

– Jag tycker man måste beakta alla människors rätt att fatta egna beslut. Men vi måste också ge förutsättningar till korrekt information om HPV-vaccinet.

{.video}
id: 14303856
storlek: full
{}


– HPV-vaccinet är väldigt säkert. Vi har i princip ingen information som tyder på att det ger några allvarliga biverkningar, säger Per Sparén, professor på Karolinska Institutet och expert på just HPV-vaccinets säkerhet.

Mellanrubrik: 80 miljoner kvinnor vaccinerade

Han betonar att vaccinet är ett av de mest välundersökta läkemedlen i världen. Det har hittills getts till över 80 miljoner kvinnor i 70 länder utan att några allvarliga biverkningar kunnat upptäckas.

– I dag har man vaccinerat över en halv miljon kvinnor i Sverige. När man jämfört dem med ovaccinerade kvinnor och följt upp olika typer av sjukdomsförekomst kan man se att det inte är någon skillnad mellan de vaccinerade och ovaccinerade kvinnorna. Det tyder på att det inte finns några allvarliga biverkningar med vaccinet, säger Per Sparén.

{.bild}
fil: hpv/Per_Sparen.jpg
storlek: s
foto: Michael Jansson/SVT
bildtext: Per Sparén, professor på Karolinska Institutet betonar att vaccinet är ett av de mest välundersökta läkemedlen i världen.
{}

Det har också gjorts flera större studier som tittat på just eventuella biverkningar och säkerheten hos HPV-vaccinet.
Bland annat har Karolinska institutet och danska Statens Serum Institut följt miljontals svenska och danska flickor och kvinnor för att se om de som vaccinerats löper större risk för exempelvis multipel skleros (MS), allvarliga allergiska reaktioner, vissa neurologiska sjukdomar samt vissa autoimmuna sjukdomar, som diabetes typ 1.

text: Resultatet: Det fanns ingen ökad risk för att utveckla sjukdomarna hos dem som vaccinerats.

Mellanrubrik: Svininfluensavaccinet påverkar

För några år sedan började några danska läkare misstänka att HPV-vaccinet kunde ha ett samband med risken att utveckla den ovanliga nervsjukdomen POTS, som kan ge svimningar, yrsel och hjärtklappning.

Dock kunde den europeiska läkemedelsmyndigheten EMA 2015, efter en längre utredning konstatera att det inte finns något som stöder att HPV-vaccinet orsakar POTS.

Men larmet påverkade danskarnas förtroende för vaccinet, vilket ledde till att antalet flickor som vaccinerades störtdök från över 70 procent till drygt 25 procent på bara några år.


En annan sjukdom som kopplats till HPV-vaccinet är narkolepsi, den sjukdom som drabbade hundratals unga svenskar efter massvaccinationen mot svininfluensan 2009.

– Vaccinet mot svininfluensan har helt klart påverkat förtroendet och befolkningens tilltro till myndigheterna, vad vi kan se i vår forskning, säger Maria Grandahl.

Hon berättar att nästan alla föräldrar som hon intervjuat i sin forskning, både de som tackat ja och nej till HPV-vaccinet, oroats över narkolepsi.

Även Agneta Englund får i sin roll som skolsköterska många frågor om just narkolepsi.

– Ja det var ju några barn som tyvärr fick narkolepsi efter pandemrixvaccinationen här i Mora och det är ju fruktansvärt att man får såna biverkningar. Jag tror det skrämde många.


{.bild}
fil: hpv/HPV_Agneta.jpg
foto: Mikael Eriksson/SVT
storlek: full
bildtext: Skolsköterskan Agneta Englund får många frågor om narkolepsi.
imgix.fp-y: 0
imgix.fp-x: 0.8
{}


Vad är då skillnaden mellan HPV-vaccinet och det vaccin som gavs vid svininfluensan?

– Det är två helt olika vacciner som är framställda på helt olika sätt, säger Per Sparén på Karolinska Institutet.

Det vaccin som togs fram inför svininfluensan hann inte testas lika grundligt som HPV-vaccinet och de allvarliga biverkningarna som vaccinet orsakade, narkolepsi, upptäcktes relativt snabbt efter att massvaccineringen inletts.

– Vi har vaccinerat många, många fler med HPV-vaccinet än som någonsin vaccinerades mot svininfluensan och vi har vaccinerat i tio års tid utan att några allvarliga risker uppdagats, säger Per Sparén.



Men många har ändå oroats över HPV-vaccinets säkerhet.
Sedan 2012 har Läkemedelsverket fått in över 700 anmälningar om misstänkta biverkningar av HPV-vaccinet Gardasil, och fem personer har fått ersättning för skador som Läkemedelsförsäkringen bedömer kan ha koppling till vaccinet. Det handlar om nervskada, hjärninflammation, yrsel, hudinflammation och allergi.

Att få ersättning från Läkemedelsförsäkringen innebär dock inte att det är bevisat att vaccinet verkligen orsakat skadan, men att det kan finnas ett sannolikt samband.

– Av en halv miljon kvinnor som vaccinerat sig med HPV-vaccin i Sverige i dag är det bara de här fem fallen som fått ersättning. Alla former av medicinska interventioner medför vissa risker, det måste man vara medveten om. Det gäller vaccinationer, cellprover, operationer eller att ta vanliga läkemedel, säger Per Sparén.

Mellanrubrik: Cellprovtagning viktigt skydd


Förutom att vaccinera sig kan man skydda sig mot livmoderhalscancer genom att gå på regelbundna cellprovtagningar, där eventuella cellförändringar kan upptäckas.

Det här är speciellt viktigt eftersom HPV-vaccinet inte skyddar mot alla HPV-typer som kan orsaka cancer och sedan slutet av 60-talet har alla svenska kvinnor mellan 23–60 år kallats till regelbundna gynekologisk cellprovtagningar.

Det är också tack vare cellprovtagningen som antalet fall av livmoderhalscancer minskat med cirka 60 procent sedan 60-talet.

En vanlig invändning från dem som tackar nej till HPV-vaccinet är att det räcker att gå på regelbundna cellprovtagningar för att undvika att drabbas av livmoderhalscancer.

Något Per Sparén inte håller med om.

Han menar att screeningprogrammet visserligen har förebyggt väldigt många fall av livmoderhalscancer, men att det inte är hundraprocentigt och dessutom ganska kostsamt.

– Om man kan förebygga det här med ett vaccin till ett bra pris är det mer kostnadseffektivt för alla. Det är också så att kvinnor som haft cellförändringar och behandlats för det har en fortsatt ökad risk att få livmoderhalscancer. Den är ungefär fördubblad livet ut för de kvinnorna. Den risken går aldrig ner och kan man förebygga med vaccin innebär det att alla har lika låg risk att drabbas.

{.citat}
stil: strong
citat: Man tänker att man är ung och frisk, jag tar det sen.
{}

För Anna Wallin, som fick sitt cancerbesked när hon var 25 år gammal, hade inte heller cellprovtagning hjälpt.

– Jag fick min första kallelse strax efter att jag fick diagnosen. Så jag hann aldrig ta något cellprov och även om jag hade fått en kallelse innan så vet jag faktiskt inte om jag hade gått. Man tänker att man är ung och frisk, jag tar det sen.

– De här cellproverna är ju bra om man kan hitta förändringarna i tid, men det är ju kanon om man kan ta fram sätt som gör att man inte ens behöver drabbas. Så om vaccinet är så pass bra som läkarna lovar så tycker jag absolut att man ska ta det.

{.bild}
fil: hpv/HPV_Anna_Ludde_3.jpg
storlek: fullwide
{}



{.sharebuttons}
title: Stora skillnader i tilltron till HPV-vaccinet
url: http://pejl.svt.se/svt-granskar-hpv-vaccin
{}

linje:


rubrik5: Johan Wicklén
luft: -40
[johan.wicklen@svt.se | mailto:johan.wicklen@svt.se | black]

rubrik5: Therese Bergstedt
luft: -40
[therese.bergstedt@svt.se | mailto:therese.bergstedt@svt.se | black]

rubrik5: [Interaktion:|em] Martin Hedström
luft: -40
[martin.hedstrom@svt.se | mailto:martin.hedstrom@svt.se | black]
[]
`;

export default page;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/hpv-granskning.js
 **/